import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
import { withTranslation, WithTranslation } from 'react-i18next';
import ChooseSsaTemplatesView from 'widgets/form/choose-ssa-template-form';
import { SsaTemplateDto } from 'stores/assessments/templates/ssa-templates-store';

export interface ChooseSsaTemplateModalButtonProps extends WithTranslation {
  onAddTemplate?: (template: SsaTemplateDto) => void;
  size: 'Normal' | 'Mini';
  profileId: string;
  selectedTemplateId: string;
  isEditMode: boolean;
}

export interface ChooseSsaTemplateModalButtonState {
  showTemplateSearchModal: boolean;
}

class ChooseSsaTemplateModalButton extends Component<ChooseSsaTemplateModalButtonProps, ChooseSsaTemplateModalButtonState> {
  state = {
    showTemplateSearchModal: false
  };

  onCancel = () => {
    this.setState({ showTemplateSearchModal: false });
  };

  handleOnAddTemplate = (template: SsaTemplateDto) => {
    this.props.onAddTemplate && this.props.onAddTemplate(template);
  };

  render() {
    const { t, isEditMode } = this.props;
    return (
      <>
        {this.props.size === 'Mini' && !isEditMode && (
          <Button
            className="step2__select-ssa__btn"
            circular
            icon="pencil"
            onClick={() => this.setState({ showTemplateSearchModal: true })}
          />
        )}
        {this.props.size === 'Normal' && !isEditMode && (
          <Button className="search-ssa-template__btn" onClick={() => this.setState({ showTemplateSearchModal: true })}>
            {t('Search SSA Templates')}
          </Button>
        )}
        {this.state.showTemplateSearchModal && (
          <ChooseSsaTemplatesView
            profileId={this.props.profileId}
            alreadySelectedTemplateId={this.props.selectedTemplateId}
            onAddTemplate={this.handleOnAddTemplate}
            onCloseTemplateModal={() => this.setState({ showTemplateSearchModal: false })}
          />
        )}
      </>
    );
  }
}

export default withTranslation()(ChooseSsaTemplateModalButton);
